import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const SearchLoadingSectionMockResultsItem_Box_1 = styled.div`
  padding-bottom: 24px;
  position: relative;
  flex: 0 0 auto;

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    padding-right: 30px;
    padding-bottom: 0;
  }
`;

export const SearchLoadingSectionMockResultsItem_Box_2 = styled.div`
  display: block;

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    display: flex;
  }
`;
